import React, {useEffect, useState} from "react";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {LoadingHelper} from "../../util/LoadingHelper";
import {ManagerService} from "../../serverService/managerManagement/ManagerService";
import {
    managerAccessLevelHeader,
    prepareManagerAccessLevelTableRow
} from "../../component/manangerDetail/ManagerAccessLevelTable";
import {ManagerAccessLevelService} from "../../serverService/managerAccessLevelService/ManagerAccessLevelService";
import ManagerRegisterResultInfo from "../../component/managerRegisterResultInfo/ManagerRegisterResultInfo";
import {css} from "@emotion/css";
import {
    DialogSize,
    RaikoAlert,
    raikoAlertTypes, RaikoButtonPrimary,
    RaikoDefaultDialogPage, RaikoFlexAlignEnd,
    RaikoGridOneColumn,
    RaikoGridTwoColumn,
    RaikoMobileInputOutlined, RaikoMultiSelectTable,
    RaikoNumberInputOutlined,
    RaikoSimpleInputOutlined,
    showErrorMessage, showWarningMessage,
    RaikoCustomSelect,
    raikoCustomSelectItemGenerator,
    RaikoToggleOutlined,
    showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {AdminRoles} from "../../context/reducer";

const ManagerAddNew = ({changeNeedRefresh,handleAddNewManagerToTable}) => {
    let page = 0
    const size = 15

    const serviceManager = new ManagerService()

    const loadingDispatcher = useLoadingDispatcher()
    const loading = new LoadingHelper(loadingDispatcher)


    const [firstName, setFirstName] = useState("")
    const [lastName, setLastName] = useState("")
    const [phoneNumber, setPhoneNumber] = useState("")
    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const [nationalCode, setNationalCode] = useState("")
    const [rolesList, setRolesList] = useState([]);
    const [role, setRole] = useState("");
    const [status, setStatus] = useState(false)


    function checkFieldsNotEmpty() {
        let state = false;

        if (firstName.length === 0) {
            showWarningMessage("خطا، لطفا نام مدیر را به درستی وارد نمایید!");
        } else if (lastName.length === 0) {
            showWarningMessage("خطا، لطفا نام خانوادگی مدیر را به درستی وارد نمایید!");
        } else if (phoneNumber.length !== 11) {
            showWarningMessage("خطا، لطفا شماره همراه مدیر را به درستی وارد نمایید!");
        } else if (nationalCode.length < 8) {
            showWarningMessage("خطا، لطفا کد ملی مدیر را به درستی وارد نمایید!")
        } else if (userName.length < 8) {
            showWarningMessage("خطا، نام کاربری باید حداقل ۸ کاراکتر باشد!");
        } else if (password.length < 8) {
            showWarningMessage("لطفا رمز عبور مدیر را وارد نمایید!");
        } else if (role.length === 0) {
            showWarningMessage("لطفا سطح دسترسی مدیر را انتخاب نمایید!")
        } else


            state = true;

        return state;
    }


    function handleChange() {
        // if (checkFieldsNotEmpty()) {
        //     loading.show()
        //     serviceManager.addNewManager(firstName, lastName, nationalCode, phoneNumber, userName, password, rolesList)
        //         .then(response => {
        //             showSuccessMessage("مدیر جدید با موفقیت افزوده شد.")
        //             handleAddNewManagerToTable(response)
        //         }).catch(reason => {
        //         showErrorMessage(detectServerErrorMessage(reason))
        //     }).finally(_ => {
        //         loading.hide()
        //     })
        // }
        handleAddNewManagerToTable({
            firstName,
            lastName,
            nationalCode,
            phoneNumber,
            userName,
            password,
            rolesList
        })
    }

    function clearFields() {
        setFirstName("")
        setLastName("")
        setNationalCode("")
        setPhoneNumber("")
        setUserName("")
        setPhoneNumber("")
        setStatus(false)
    }


    const [openDialog, setOpenDialog] = useState(false);
    const [adminUsername, setAdminUsername] = useState("");
    const [adminPassword, setAdminPassword] = useState("");

    function handleCloseDialog() {
        setOpenDialog(false)
        clearFields()
    }

    return (
        <>
            <RaikoDefaultDialogPage
                onClose={handleCloseDialog}
                open={openDialog}
                dialogSize={DialogSize.WRAP_CONTENT}
                pageTitle={"اطلاعات مدیر"}
            >
                <ManagerRegisterResultInfo
                    handleCloseDialog={handleCloseDialog}
                    alertTitle={"مدیر جدید با موفقیت افزوده شد."}
                    alertDescription={[
                        `* نام کاربری، گذر واژه و نشانی سامانه از طریق پیامک (${phoneNumber}) برای مدیر محترم ارسال شد.`,
                    ]}
                    username={adminUsername}
                    password={adminPassword}
                />
            </RaikoDefaultDialogPage>
            <RaikoGridOneColumn
                className={css`
                    padding: 0 1rem 1rem 1rem;
                    width: 100%;
                    height: 100%;`}
            >

                <RaikoGridTwoColumn>
                    <RaikoSimpleInputOutlined
                        value={firstName}
                        setValue={setFirstName}
                        labelText={"نام"}
                    />
                    <RaikoSimpleInputOutlined
                        value={lastName}
                        setValue={setLastName}
                        labelText={"نام خانوادگی"}
                    />
                    <RaikoNumberInputOutlined
                        maxLength={"10"}
                        value={nationalCode}
                        setValue={setNationalCode}
                        labelText={"کد ملی"}
                    />

                    <RaikoMobileInputOutlined
                        value={phoneNumber}
                        setValue={setPhoneNumber}
                        labelText={"شماره همراه"}
                    />
                    <RaikoSimpleInputOutlined
                        value={userName}
                        setValue={setUserName}
                        labelText={"نام کاربری"}
                    />
                    <RaikoSimpleInputOutlined
                        value={password}
                        setValue={setPassword}
                        labelText={"رمز عبور"}
                    />
                    <RaikoCustomSelect
                        labelText={"سطح دسترسی"}
                        value={role}
                        setValue={setRole}
                        onChange={e => {
                            setRole(e.target.value)
                            setRolesList([e.target.value])
                        }}
                        items={[
                            raikoCustomSelectItemGenerator(AdminRoles.SUPER_ADMIN.role, AdminRoles.SUPER_ADMIN.name),
                            raikoCustomSelectItemGenerator(AdminRoles.FUND_MANAGER.role, AdminRoles.FUND_MANAGER.name),
                            raikoCustomSelectItemGenerator(AdminRoles.SITE_MANAGER.role, AdminRoles.SITE_MANAGER.name),
                        ]}
                    />
                    <RaikoToggleOutlined
                        labelText={"مسدود سازی"}
                        setChecked={setStatus}
                        checked={status}
                    />
                </RaikoGridTwoColumn>


                <RaikoFlexAlignEnd>
                    <RaikoButtonPrimary label={"افزودن مدیر"} onClick={handleChange}/>
                </RaikoFlexAlignEnd>
            </RaikoGridOneColumn>


        </>

    )
}
export default ManagerAddNew

